import Color from 'color'
import { DefaultTheme } from 'styled-components'

export const breakpoints = {
  mobile: 991,
}

export const mediaQueries = {
  landscape: `@media only screen and (max-width: ${breakpoints.mobile}px) and (orientation: landscape)`,
  mobile: `@media only screen and (max-width: ${breakpoints.mobile}px)`,
  desktop: `@media only screen and (min-width: ${breakpoints.mobile + 1}px)`,
}

export const theme: DefaultTheme = {
  fontFamily: 'Roboto',
  primaryColor: '#0a5b8b',
  secondaryColor: Color('#0a5b8b').darken(0.3).string(),
  primaryFontColor: '#000',
  secondaryFontColor: '#fff',
  colors: {
    abyss: '#08153A',
    lightAbyss: '#1C294E',
    eveningLight: '#0679AB',
    green: '#00a86b',
    red: '#ff6f61',
    textGrey: '#525B75',
    backgroundColor: '#fafcfc',
    darkGrey: '#E5EAEB',
    lightGrey: '#f5f7f8',
    yellow: '#fabf5e',
  },
  breakpoints,
  mediaQueries,
}

export default theme
